module.exports = __webpack_public_path__ + "static/media/document-duplicate.03ade3ad.svg";